import {GraphQLFormattedError} from 'graphql'

export interface AppConfig{
    name:string,
    branch:string,
    courseId:string,
    coverImage:string
}

export class Utils {
  static GLOBAL_LOG_LEVEL=1; //2=debug, 3=info
  
  static appConfig:AppConfig;
 
  static getDataFromResult<T>(data: T, errors: any, context?: string): T {
    const errorMessage = context ? `Could not retrieve data in [${context}]` : `Could not retrieve data`;
    if (errors) {
        throw `${errorMessage}, errors => ${JSON.stringify(errors)}`;
    } else {
        return data;
    }
}

  /** New error handling function, should replace the one below over time */
  static handleError(result: any, errorMsg?:string){
    if(!result){throw Error(`Undefined amplify result - [${errorMsg}]`);}
    if(!result.data){throw Error(`Amplify result with no data - [${errorMsg}]`);}

    if(result.error){
      let errorList="";
      if(Array.isArray(result.errors)){
        result.errors.forEach((err: { message: string; }) =>{
          errorList = errorList.concat(err.message+'\n')
        });
        throw Error(`Amplify error - [${errorMsg}] => ${errorList}`);
      }else{
        throw Error(`Amplify error - [${errorMsg}] => ${result.errors}`);
      }
    }
  }

  static handleAmplifyErrors(errorMessage:string,data:any|undefined,errors: GraphQLFormattedError[]|undefined,){
    let errorList="";
    if(errors != undefined){
      if(Array.isArray(errors)){
        errors.forEach(error =>{errorList = errorList.concat(error.message+'\n')});
        throw new Error(`${errorMessage}=>${errorList}`);
      }else{
        throw new Error(`${errorMessage}=>${errors}`);
      }
    }
    // if(!data){
    //   throw new Error('No data returned from appsync');
    // }
  }

  static stripHtml(htmlString: string): string {
    return htmlString.replace(/<\/?[^>]+(>|$)/g, '');
  }
}

